import EconomyGraph from "@/components/EconomyGraph";
import PaymentDemo from "@/components/PaymentDemo";
import { Corners, GlowButton, PageHead, Reveal, SectionHeader, Tag } from "@/components/ui-kit";
import ContractChip from "@/components/ContractChip";
import { BUY_URL, DEXSCREENER_URL } from "@/config";

const RESOURCES = ["COMPUTE", "DATA", "ENERGY", "MAPS", "APIs", "TRANSPORTATION", "ROBOTIC SERVICES", "HUMAN SERVICES"];

const EconomyPage = () => (
  <div data-testid="economy-page" className="pb-24">
    <PageHead
      eyebrow="MODULE 05 // VALUE LAYER"
      title="THE MACHINE ECONOMY"
      subtitle="When machines become economic participants. Autonomous systems will need to discover, purchase and provide resources — without waiting for human approval."
    />
    <div className="px-5 sm:px-8 max-w-7xl mx-auto space-y-20">
      <section className="grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <SectionHeader index="FLOW // CIRCULAR" title={"A CLOSED LOOP OF\nMACHINE COMMERCE"} subtitle="Machines may eventually require compute, data, energy, maps, APIs, transportation, robotic services and human services. ARCMECH explores how those flows close into an autonomous economy." />
          <div className="flex flex-wrap gap-2 -mt-4">
            {RESOURCES.map((r) => <Tag key={r} tone="silver">{r}</Tag>)}
          </div>
        </Reveal>
        <Reveal delay={0.15}><EconomyGraph /></Reveal>
      </section>

      <section>
        <SectionHeader index="DEMO // M2M PAYMENT" title="MACHINE-TO-MACHINE PAYMENT" subtitle="A visual simulation of how a machine could request a service, authorize a payment and settle — end to end." />
        <Reveal><PaymentDemo /></Reveal>
      </section>

      <section>
        <Reveal>
          <div className="hud-panel relative p-6 sm:p-8 grid md:grid-cols-2 gap-8 items-center">
            <Corners />
            <div>
              <div className="eyebrow mb-2">TOKEN // ECOSYSTEM</div>
              <h3 className="font-display text-2xl font-bold text-arc-white tracking-wide">$ARCMECH ON ARC</h3>
              <p className="mt-3 text-sm text-arc-silver/70 leading-relaxed">
                $ARCMECH is the ecosystem token. The contract is live on ARC — always verify the address via the official X channel before transacting. Market metrics such as supply and allocation will be displayed once officially published.
              </p>
              <div className="mt-4"><ContractChip /></div>
              <div className="mt-6 flex flex-wrap gap-3">
                <GlowButton href={BUY_URL} testId="economy-buy-button" cursor="TARGET">BUY $ARCMECH</GlowButton>
                {DEXSCREENER_URL ? (
                  <GlowButton href={DEXSCREENER_URL} variant="ghost" testId="economy-chart-button" cursor="OPEN">VIEW CHART</GlowButton>
                ) : (
                  <GlowButton variant="ghost" testId="economy-chart-button" className="opacity-60 cursor-not-allowed" cursor="SCAN">CHART — COMING SOON</GlowButton>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3 font-mono text-[11px] tracking-[0.15em]">
              {[["TOKEN", "$ARCMECH", "text-arc-white"], ["NETWORK", "ARC", "text-arc-white"], ["CONTRACT", "0x5e01…f5aD", "text-arc-cyan"], ["BUY", "ARGUS", "text-arc-cyan"], ["CHART", "DEXSCREENER", "text-arc-cyan"], ["SUPPLY", "COMING SOON", "text-amber-300"]].map(([k, v, c]) => (
                <div key={k} className="border border-arc-blue/15 p-3">
                  <div className="text-arc-silver/40 text-[9px] tracking-[0.3em] mb-1">{k}</div>
                  <div className={c}>{v}</div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  </div>
);

export default EconomyPage;
